import { emptySplitApi } from "./empty-split-api";
import { AiVisualization, AiVisualizationRequestBody } from "./types/ai.type";

export const aiApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getAiVisualization: builder.query<
      AiVisualization,
      AiVisualizationRequestBody
    >({
      query: (body) => ({
        url: `/ai/visualization/ask/`,
        method: "POST",
        body,
      }),
    }),
  }),
});

export const { useGetAiVisualizationQuery, useLazyGetAiVisualizationQuery } =
  aiApi;
